import React from 'react';
import '../assets/styles/global.sass';
import Top from './Top';
import Footer from './Footer';
import { Helmet } from 'react-helmet'

const Layout = (props) => (
  <>
    <Helmet>
      <title>{props.title ? props.title : 'La Leyenda Adventures'}</title>
      <meta name="description" content={props.description ? props.description : 'La Leyenda Adventures - simplemente las mejores experiencias de ciclismo que puedes encontrar en América del Sur.'} />
      <meta property="og:title" content={props.title ? props.title : 'La Leyenda Adventures'} />
      <meta property="og:description" content={props.description ? props.description : 'La Leyenda Adventures - simplemente las mejores experiencias de ciclismo que puedes encontrar en América del Sur.'} />
    </Helmet>
    <div className="container-fluid">
      <Top />
      {props.children}
      <Footer />
    </div>
  </>
)

export default Layout;
